import { render, staticRenderFns } from "./vendorAfterSale.vue?vue&type=template&id=eebb9436&scoped=true"
import script from "./vendorAfterSale.vue?vue&type=script&lang=js"
export * from "./vendorAfterSale.vue?vue&type=script&lang=js"
import style0 from "./vendorAfterSale.vue?vue&type=style&index=0&id=eebb9436&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eebb9436",
  null
  
)

export default component.exports